module.exports = __webpack_public_path__ + "static/media/powerSupply.d41d82db.svg";